import {combineReducers} from "redux"
import approvals from "reducers/customerContext/approvals"

export default combineReducers({
  approvals,
})
